module.exports = __webpack_public_path__ + "static/media/signstream-black.5ee9b0c3.png";